<template>
  <el-card class="h-full absolute inset-0 z-10">
    <div class="h-full flex flex-col">
      <span
        v-if="!(formProps.editType === 'read' || formProps.editType === 'todoSubmit')"
        class="border-l-3 border-color-primary pl-10px text-18px"
        >设备设施评估编辑</span
      >
      <div v-else>
        <el-page-header @back="$emit('cancel')" content="设备设施危险源详情"></el-page-header>
      </div>
      <div class="flex-1 overflow-y-auto mt-20px">
        <el-collapse v-model="collapseActiveName">
          <el-collapse-item title="风险点基本信息" name="baseInfo">
            <equip-form :taskId="taskId"></equip-form>
          </el-collapse-item>
          <el-collapse-item name="risk" title="危险源辨识">
            <equip-identify ref="riskIdentify" :taskId="identifyId" disabled />
          </el-collapse-item>
          <el-collapse-item name="control" title="管控措施">
            <control-measure
              ref="controlMeasure"
              :taskId="taskId"
              :projectId="projectId"
              :identifyId="identifyId"
              :disabled="formProps.editType === 'read'"
            />
          </el-collapse-item>
          <el-collapse-item name="evaluate" title="风险评级">
            <risk-evaluate
              :projectId="projectId"
              :taskId="taskId"
              :evaluateMethod="evaluateMethod"
              :identifyId="identifyId"
              ref="riskEvaluate"
              :isDisabled="formProps.editType === 'read'"
            ></risk-evaluate>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="flex justify-center mt-20px" v-if="formProps.editType !== 'read'">
        <el-button
          type="primary"
          size="small"
          @click="submitForm('save')"
          :disabled="pubLoading || formProps.editType === 'todoSubmit'"
          :loading="saveLoading"
          >保存</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="submitForm('submit')"
          :disabled="saveLoading"
          :loading="pubLoading"
          >提交</el-button
        >
        <el-button @click="$emit('cancel')" size="small">取消</el-button>
      </div>
    </div>
  </el-card>
</template>

<script>
import { SourcesDangerRecognitionRiskRatingApi } from '@wiz-api/double-prevention-management'
import ControlMeasure from '../business/ControlMeasure'
import EquipIdentify from '../business/EquipIdentify'
import RiskEvaluate from '../business/RiskEvaluate'
import EquipForm from '../business/EquipForm'

const sourcesDangerRecognitionRiskRatingApi = new SourcesDangerRecognitionRiskRatingApi()

export default {
  name: 'control-equip-form',
  components: {
    EquipIdentify,
    ControlMeasure,
    RiskEvaluate,
    EquipForm,
  },
  props: {
    taskId: {
      type: String,
      default: null,
    },
    projectId: {
      type: String,
      default: null,
    },
    identifyId: {
      type: String,
      default: null,
    },
    evaluateMethod: {
      type: Number,
      default: null,
    },
    formProps: {
      default: () => {
        return {
          title: '新增设备设施辨识',
          editType: 'create',
          visible: true,
        }
      },
    },
  },
  data() {
    return {
      saveLoading: false,
      pubLoading: false,
      collapseActiveName: ['baseInfo', 'risk', 'evaluate', 'control'],
    }
  },
  methods: {
    /**
     *
     * @param {*} type 提交 保存
     */
    async submitForm(type) {
      // 管控和评级校验通过
      if (this.$refs.controlMeasure.validate() && this.$refs.riskEvaluate.validate()) {
        type === 'save' ? (this.saveLoading = true) : (this.pubLoading = true)
        let resultForm = {}
        const tableData = this.$refs.controlMeasure.tableData
        const formData = this.$refs.riskEvaluate.formData
        resultForm = {
          ...formData,
          dRiskValue: `${formData.dRiskValue}`,
          sourcesDangerRecognitionRiskAssessControltDtos: tableData,
        }
        let err = null
        let res = null
        // riskRatingStatus 0代表新增 1代表发布
        this.$set(resultForm, 'riskRatingStatus', type === 'save' ? 0 : 1)
        if (resultForm.id) {
          // 编辑
          ;[err, res] = await sourcesDangerRecognitionRiskRatingApi.update(resultForm.id, {
            body: resultForm,
          })
          if (!err) {
            this.$message({
              showClose: true,
              message: '编辑成功',
              type: 'success',
            })
            this.$emit('refreshList')
          }
        } else {
          // 新增
          ;[err, res] = await sourcesDangerRecognitionRiskRatingApi.create({ body: resultForm })
          if (!err) {
            this.$message({
              showClose: true,
              message: '新增成功',
              type: 'success',
            })
            this.$emit('refreshList')
          }
        }
        type === 'save' ? (this.saveLoading = false) : (this.pubLoading = false)
      }
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
</style>
